/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';

import { userAsPromise } from '../providers/userProvider';

interface IRepetitionDefinition {
  start: number;
  end: number;
}

interface IExcludeRepetitionsRequest {
  testId: string;
  repetitions: IRepetitionDefinition[];
}

/**
 * @description enable or disable repetitions
 * @param request
 * @returns
 */
export async function excludeRepetitions(
  request: IExcludeRepetitionsRequest
): Promise<HttpsCallableResult<unknown>> {
  const requestingUser = await userAsPromise();
  const fn = httpsCallable(
    requestingUser.services.functions,
    'excludeRepetitions'
  );
  return fn(request);
}
